export default {
      id: "tag-outline-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#tag-outline",
      toString: function () {
        return this.url;
      }
    }